export default __webpack_public_path__ + "images/0xfe712251173a2cd5f5be2b46bb528328ea3565e1.png";